import {combineReducers} from 'redux';
// import AuthReducer from "./AuthReducer";
import CompanyMappingModulenReducers from './CompanyMappingModule/index';

export default combineReducers({
  company_mapping: CompanyMappingModulenReducers
});
